// extracted by mini-css-extract-plugin
export default {"container":"SideLayout_container__xyc2a","side":"SideLayout_side__lPjNB","content":"SideLayout_content__c0MrR"};